import React, { useState } from "react";
import * as MUI from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { StarBorderRounded, StarRounded } from "@material-ui/icons";

import { DeleteFavouriteDialog } from "../DeleteFavouriteDialog";
import { useStyles } from "./FavouriteButton.styles";
import { IFavouriteButtonProps } from "./FavouriteButton.types";

export const FavouriteButton: React.FC<IFavouriteButtonProps> = (props) => {
  const { favouriteItem, isLoading, isDisabled, handleDelete, handleAdd } = props;
  const classes = useStyles();
  const [deleteFavouriteDialogOpen, setDeleteFavouriteDialog] = useState(false);

  if (isLoading) {
    return <Skeleton className={classes.root} variant="circle" width={48} height={48} />;
  }

  return (
    <>
      <MUI.IconButton
        className={classes.root}
        aria-label="Favourite"
        disabled={isDisabled}
        onClick={favouriteItem ? () => setDeleteFavouriteDialog(true) : handleAdd}
      >
        {favouriteItem ? <StarRounded className={classes.icon} /> : <StarBorderRounded className={classes.icon} />}
      </MUI.IconButton>
      {favouriteItem && (
        <DeleteFavouriteDialog
          favouriteItemName={favouriteItem.name}
          onDelete={() => {
            setDeleteFavouriteDialog(false);
            handleDelete();
          }}
          open={deleteFavouriteDialogOpen}
          handleCloseDialog={() => setDeleteFavouriteDialog(false)}
        />
      )}
    </>
  );
};
